import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HelpModel } from 'common/models/page-models/help/help-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { HelpFormWidgetService } from 'common/widget/help/help-form-widget.service';



@Injectable({
    providedIn: 'root'
})
export class HelpFormResolver extends FormResolverService<HelpModel> {
    constructor(
        protected fs: HelpFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
      
    }
}

